import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import DatePicker from 'vue2-datepicker'


export default {
	name: 'shipmentdetails',
	components: {
		BasicSelect,
		VueElementLoading,
		DatePicker
	},
	props: ['hubid'],
	data() {
		return {
			showBagsDetailsModal:false,
			DataName:'',
			DataTypelist:[
				{
	        value: 1,
	        text: "InScan"
	      }, {
	        value: 2,
	        text: "LHHandover"
	      },{
	        value: 3,
	        text: "BagClosed"
	      }
			],
			DataType:{
				text: '',
				value: ''
			},

			hubLoading: '',
			bagtDetailsList: [],
			hubid: '',
			fromdate: '',
			todate: '',
			totalBags:'',
			isLoading:false
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
	},
	mounted() {
	},
	methods: {
		SelectDataType(obj) {
      this.DataType = obj
      this.DataName = obj.text
    },
		dateFormat(date) {
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		getShipmentList() {
			this.showBagsDetailsModal = false,
			this.isLoading=true,
			this.input = ({
				"DataFrom":this.DataName,
				"FromDate":this.dateFormat(this.fromdate),
				"ToDate":this.dateFormat(this.todate),
				"ProcessLocation":this.hubid
			})
			axios({
					method: 'POST',
				 	url: apiUrl.api_url_hubops + 'pushBagDetailsToBagSorter',
					data: this.input,
					headers: {
						'Authorization': "authkey xB84JJ89Hd25"
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.isLoading=false,
						this.bagDetailsList = result.data.ResponseData;
						this.totalBags=this.bagDetailsList.length
						this.showBagsDetailsModal=true;
						this.$alertify.success(result.data.ReturnMessage)

					} else {
						this.isLoading=false,
						this.pageCount = 0
						this.shipmentDetailsList = [];
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					this.isLoading = false
					console.error(error)

				})
		},

		resetflt() {
			this.isLoading=false,
			this.BagsDetailsList = [],
		  this.fromdate = '',
		  this.todate = '',
		  this.DataName = '',
		  this.DataType = {
		    text: '',
		    value: '',
		  },
		  this.showBagsDetailsModal = false,
		  this.fromdate = '',
		  this.todate = '',
		  this.$validator.reset(),
			this.totalBags=''
		},
		onSubmitflt: function() {

			var self = this
			this.$validator.validateAll().then((result) => {
			 if (!result) {
					return false
				} else {
					this.getShipmentList();
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/BagSorter/PushDetails/pushDetails.js